import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { BookOpen, Cross, Feather, Church, Heart, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';
import { faithStatements, ministryLinks, publicCtas } from '@/content/public-site-content';

const iconMap: Record<string, React.ElementType> = {
  BookOpen,
  Feather,
  Cross,
  Church,
  Heart,
  Globe,
};

export default function StatementOfFaithPage() {
  return (
    <div className="max-w-6xl mx-auto w-full p-6 space-y-8">
      <div className="text-center space-y-4">
        <Badge variant="outline" className="mb-2">
          <BookOpen className="mr-1 h-3 w-3" />
          Ministry
        </Badge>
        <h1 className="text-4xl font-bold">Statement of Faith</h1>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
          The foundational beliefs that guide Dominion Mandate
        </p>
      </div>

      <Card className="bg-primary/5 border-primary/20">
        <CardContent className="p-8 text-center max-w-3xl mx-auto">
          <BookOpen className="h-12 w-12 text-primary mx-auto mb-4" />
          <h2 className="text-xl font-bold mb-4">Our Foundation</h2>
          <p className="text-muted-foreground">
            Discover how we view God, Jesus, the Bible, man, and many significant aspects of
            our faith. Our beliefs are shaped by biblical truths and our decisions as a church
            are guided by Scripture.
          </p>
        </CardContent>
      </Card>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {faithStatements.map((statement) => {
          const Icon = iconMap[statement.icon] || BookOpen;
          return (
            <Card key={statement.title} className="border-border/70 bg-card/90 shadow-sm">
              <CardHeader>
                <Icon className="h-8 w-8 text-primary mb-2" />
                <CardTitle className="text-xl">{statement.title}</CardTitle>
                <CardDescription className="text-sm leading-6">
                  {statement.description}
                </CardDescription>
              </CardHeader>
            </Card>
          );
        })}
      </div>

      <Card className="border-border/70">
        <CardContent className="p-8 text-center">
          <h2 className="text-xl font-bold mb-2">Explore More</h2>
          <p className="text-muted-foreground mb-6">
            Continue with the ministry values, the broadcast, or a direct contact step.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {ministryLinks.filter(l => l.label !== 'Statement of Faith').map((link) => (
              <Link key={link.href} to={link.href}>
                <Badge variant="outline" className="text-sm px-4 py-2 cursor-pointer hover:bg-primary/10">
                  {link.label}
                </Badge>
              </Link>
            ))}
            {publicCtas.slice(0, 3).map((cta) => (
              <Link key={cta.href} to={cta.href}>
                <Button variant={cta.href === '/media' ? 'default' : 'outline'}>
                  {cta.label}
                </Button>
              </Link>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
